(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gp-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scrollBars = [];
    var ticking = false;

    // Hoist the fixed bar to <body> so ancestor transforms/overflow don't trap it.
    function hoist() {
      var bars = document.querySelectorAll('[data-gp-sticky]:not([data-gp-hoisted])');
      for (var i = 0; i < bars.length; i++) {
        var bar = bars[i];
        bar.setAttribute('data-gp-hoisted', '1');
        document.body.appendChild(bar);
        if (bar.getAttribute('data-gp-reveal') === 'scroll' && scrollBars.indexOf(bar) === -1) {
          scrollBars.push(bar);
        }
      }
      check();
    }
    function removeHoisted(id) {
      var sel = id
        ? '[data-gp-sticky="' + id + '"][data-gp-hoisted]'
        : '[data-gp-sticky][data-gp-hoisted]';
      var els = document.querySelectorAll(sel);
      for (var i = 0; i < els.length; i++) {
        var idx = scrollBars.indexOf(els[i]);
        if (idx !== -1) scrollBars.splice(idx, 1);
        els[i].parentNode.removeChild(els[i]);
      }
    }
    function check() {
      ticking = false;
      if (!scrollBars.length) return;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var vh = window.innerHeight || 1;
      for (var i = 0; i < scrollBars.length; i++) {
        var bar = scrollBars[i];
        if (bar.getAttribute('data-gp-dismissed') === '1') continue;
        var mult = parseFloat(bar.getAttribute('data-gp-reveal-vh')) || 1;
        if (y >= vh * mult) {
          bar.classList.add('gp-sticky--visible');
        } else {
          bar.classList.remove('gp-sticky--visible');
        }
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hoist);
    } else {
      hoist();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', function (e) {
      removeHoisted(e && e.detail ? e.detail.sectionId : null);
      hoist();
    });
    document.addEventListener('shopify:section:unload', function (e) {
      removeHoisted(e && e.detail ? e.detail.sectionId : null);
    });
    document.addEventListener('click', function (event) {
      var closeBtn = event.target.closest('[data-gp-sticky-close]');
      if (!closeBtn) return;
      var bar = closeBtn.closest('[data-gp-sticky]');
      if (bar) {
        bar.setAttribute('data-gp-dismissed', '1');
        bar.classList.add('gp-sticky--dismissed');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mph-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.mph-testimonials__wrap');
    roots.forEach(function (wrap) {
      var track = wrap.querySelector('[data-mph-track]');
      if (!track) return;
      var prev = wrap.querySelector('[data-mph-dir="prev"]');
      var next = wrap.querySelector('[data-mph-dir="next"]');

      function step() {
        var item = track.querySelector('.mph-testimonials__item');
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function update() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        prev.hidden = track.scrollLeft <= 1;
        next.hidden = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();

      var speed = parseInt(track.getAttribute('data-mph-autoplay'), 10);
      if (speed > 0) {
        var timer = null;
        function play() {
          timer = setInterval(function () {
            var max = track.scrollWidth - track.clientWidth - 1;
            if (track.scrollLeft >= max) {
              if (track.hasAttribute('data-mph-loop')) {
                track.scrollTo({ left: 0, behavior: 'smooth' });
              }
            } else {
              track.scrollBy({ left: step(), behavior: 'smooth' });
            }
          }, speed);
        }
        function stop() { if (timer) { clearInterval(timer); timer = null; } }
        play();
        wrap.addEventListener('mouseenter', stop);
        wrap.addEventListener('mouseleave', play);
        wrap.addEventListener('focusin', stop);
        wrap.addEventListener('touchstart', stop, { passive: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
